
import XTable from 'vux/src/components/x-table/index.vue'

import { mapMutations } from 'vuex'
export default {
name: 'Classificationcriteriaforfunctionalstatusofrheumatoidarthritisjoints',
components: {
XTable
},
created () {
this.hideLoad()
},
methods: {
...mapMutations(['hideLoad'])
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/Classificationcriteriaforfunctionalstatusofrheumatoidarthritisjoints.vue